import React, { useState, useEffect } from "react";
import {
  Breadcrumb,
  Divider,
  Button,
  Card,
  Select,
  Collapse,
  Form,
  Input,
  Row,
  Col,
  Radio,
  Empty,
  Dropdown,
  Menu,
  Modal
} from "antd";
import { HomeOutlined , OrderedListOutlined, ArrowUpOutlined, ArrowDownOutlined, ExclamationCircleOutlined} from "@ant-design/icons";
import * as Icon from "react-feather";
import { useDispatch } from 'react-redux';
import appLoaderAction from '../../../redux/action/app-loader-action';
import notifyUtitls from '../../../utils/notify-utils';
import documentGalleryService from "../../../services/document-gallery-service";
import AddEditFolderDialog from "./AddEditFolderDialog";
import AddEditDocumentDialog from "./AddEditDocumentDialog";
import { galleryType } from "../../../constants/app-constants";
import GalleryDocumentCard from "../../../components/gallery/document/gallery-card";
import ListDocumentCard from "../../../components/gallery/document/list-card";
import fileUtils from "../../../utils/file-utils";

const { Option } = Select;
const { Panel } = Collapse;
const { confirm } = Modal;


const Document = ({ isHtmlModal }) => {
  const dispatch = useDispatch();
  const [isShowAddFileDialog, setIsShowAddFileDialog] = useState(false);
  const [isShowAddDocumentDialog, setIsShowAddDocumentDialog] = useState(false);
  const [condition, setCondition] = useState({
    fileName: null,
    type: null,
    parent: 'root',
    path: '',
    folder: false
  });
  const [editFolderData, setEditFolderData] = useState(null);
  const [editDocumentData, setEditDocumentData] = useState(null);
  const [displayList, setDisplayList] = useState([]);
  const [displayGroup, setDisplayGroup] = useState('a');
  const [currentParent, setCurrentParent] = useState("root");
  const [currentPath, setCurrentPath] = useState(null);
  const [currentFolder, setCurrentFolder] = useState(null);
  const [sortAscFlag, setSortAscFlag] = useState(false);

  useEffect(() => {
    doSearch();
  }, []);

  const onChangeSelection = (value) => {
    setCondition({ ...condition, type: value, parent: null });
  }

  const onChangeCondition = (event) => {
    const { name, value } = event.target;
    setCondition({ ...condition, [name]: value, parent: null });
  }

  const doSearch = async (payload) => {
    try {
      dispatch(appLoaderAction.enable());
      if (payload) {
        const result = await documentGalleryService.search(payload);
        setCurrentParent(payload.parent);
        setDisplayList(result.list);
      } else {
        const newCondition = { fileName : condition.fileName, type : condition.type, parent: condition.parent }
        const result = await documentGalleryService.search(newCondition);
        setCurrentParent(condition.parent);
        setCurrentPath(null);
        setDisplayList(result.list);
      }
      dispatch(appLoaderAction.disale());
    } catch (err) {
        dispatch(appLoaderAction.disale());
        dispatch(notifyUtitls.error(err));
    }
  };

  const onOpenFolder = async (value) => {
    try {
      // console.log('test clickOpen', value);
      dispatch(appLoaderAction.enable());
      const newCondition = { parent: value.id }
      const result = await documentGalleryService.search(newCondition);
      setCurrentParent(value.id);
      if (currentPath) {
        setCurrentPath([
          ...currentPath,
          value.folderName
        ]);
      } else {
        setCurrentPath([
          value.folderName
        ]);
      }

      setCurrentFolder(value.folderName);
      setDisplayList(result.list);
      dispatch(appLoaderAction.disale());
    } catch (err) {
        dispatch(appLoaderAction.disale());
        dispatch(notifyUtitls.error(err));
    }
  }

  const onClearSearch = () => {
    setCondition({
      fileName: null,
      type: null,
      parent: 'root',
      folder: false
    });
    setDisplayList(null);
    setCurrentParent("root");
    setCurrentPath(null);
    setCurrentFolder(null);
  }

  const displayGroupHandler = (event) => {
    setDisplayGroup(event.target.value);
  }

  const onAddFolder = () => {
    setIsShowAddFileDialog(true);
    setEditFolderData(null);
  }

  const onAddDocument = () => {
    setIsShowAddDocumentDialog(true);
    setEditDocumentData(null);
  }

  const onCancelAddFolder = () => {
		setIsShowAddFileDialog(false);
		setEditFolderData(null);
	};

  const onAddFolderComplete = () => {
    setIsShowAddFileDialog(false);
    setEditFolderData(null);
    doSearch({parent: currentParent})
	};

  const onCancelAddDocument = () => {
    setIsShowAddDocumentDialog(false);
		setEditDocumentData(null);
	};

  const onAddDocumentComplete = () => {
    setIsShowAddDocumentDialog(false);
    setEditDocumentData(null);
    doSearch({parent: currentParent})
	};

  const onClickEdit = async (value) => {
    // console.log('test clickEdit', value);
    try {
        dispatch(appLoaderAction.enable());
        // const editData = await photoGalleryService.getById({id: id});
        value.folder ? onEditFolder(value) : onEditDocument(value);
        dispatch(appLoaderAction.disale());
    } catch (err) {
        dispatch(appLoaderAction.disale());
        notifyUtitls.error(err);
    }
  }

  const onEditDocument = (data) =>{
    setEditDocumentData(data);
    setIsShowAddDocumentDialog(true);
  }

  const onEditFolder = (data) =>{
    setEditFolderData(data);
    setIsShowAddFileDialog(true);
  }

  const onConfirmDelete = (id) => {
    confirm({
      title: 'คุณต้องการลบใช่หรือไม่ ?',
      icon: <ExclamationCircleOutlined />,
      okText: 'ยืนยัน',
      okType: 'danger',
      cancelText: 'ยกเลิก',
      onOk() {
        onDelete(id);
      },
      onCancel() {
        
      },
    });
  }

  const onDelete = async (id) => {
    try {
        dispatch(appLoaderAction.enable());
        await documentGalleryService.remove({deleteId: id});
        dispatch(appLoaderAction.disale());
        notifyUtitls.success('สำเร็จ', 'ลบข้อมูลสำเร็จ');
        doSearch({parent: currentParent});
    } catch (err) {
        dispatch(appLoaderAction.disale());
        notifyUtitls.error(err);
    }
  };

  const onEmbed = async (id) => {
    dispatch(appLoaderAction.enable());
    await documentGalleryService.generateLinkDocumentGalleryById({id: id})
      .then((res) => {
        if (navigator.clipboard) {
          navigator.clipboard.writeText(res.link);
        } else {
          let textArea = document.createElement("textarea");
          textArea.value = res.link;
          textArea.style.position = "fixed";
          textArea.style.left = "-999999px";
          textArea.style.top = "-999999px";
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();
          document.execCommand('copy');
          textArea.remove();
        }
        notifyUtitls.success('สำเร็จ', 'สร้างลิ้งค์');
      }).catch((err) => {
        notifyUtitls.error(err);
      }).finally(() => {
        dispatch(appLoaderAction.disale());
    });
  }

  const moveFileHandler = async (fileMove, folder) => {
    // console.log('dragValue', fileMove);
    // console.log('folder,', folder);

    if (folder.folder !== 'true') {
      try {
        dispatch(appLoaderAction.enable());
        let path = "/"
        if (currentPath) {
          currentPath.forEach((res) => {
            path = path + res + "/";
          });
          path = path + folder.folderName + "/"
        } else {
          path = path + folder.folderName + "/"
        }

        const moveValue = {
          bean: {
            id: fileMove.id,
            fileName: fileMove.fileName,
            type: fileMove.type,
            path: fileMove.path,
            parent: folder.id,
            folder: fileMove.folder,
            newPath: path
          }
        }
        await documentGalleryService.moveFile(moveValue);
        doSearch({parent: currentParent});
        dispatch(appLoaderAction.disale());
        notifyUtitls.success('สำเร็จ', 'ย้ายข้อมูลสำเร็จ');
      } catch (err) {
        dispatch(appLoaderAction.disale());
        notifyUtitls.error(err);
      }
    }
  }

  const onSort = (value) => {
    switch (value) {
      case 'sortName':
        const newDisplayListName = displayList.sort((a, b) => {
          const prevFname = a.folderName || a.fileName;
          const nextFname = b.folderName || b.fileName;
          if (!sortAscFlag) {
            setSortAscFlag(!sortAscFlag);
            if ( prevFname < nextFname ){
              return -1;
            }
            if ( prevFname > nextFname ){
              return 1;
            }
            return 0;
          } else {
            setSortAscFlag(!sortAscFlag);
            if ( prevFname < nextFname ){
              return 1;
            }
            if ( prevFname > nextFname ){
              return -1;
            }
            return 0;
          }
        });
        setDisplayList([...newDisplayListName]);
        break;
      case 'sortSize':
        const newDisplayListSize = displayList.sort((a, b) => {
          const prevFname = a.size;
          const nextFname = b.size;
          if (!sortAscFlag) {
            setSortAscFlag(!sortAscFlag);
            if ( prevFname < nextFname ){
              return -1;
            }
            if ( prevFname > nextFname ){
              return 1;
            }
            return 0;
          } else {
            setSortAscFlag(!sortAscFlag);
              if ( prevFname < nextFname ){
              return 1;
            }
            if ( prevFname > nextFname ){
              return -1;
            }
            return 0;
          }          
        });
        setDisplayList([...newDisplayListSize]);
        break;
      case 'sortDate':
        const newDisplayListDate = displayList.sort((a, b) => {
          const prevFname = a.updateTime;
          const nextFname = b.updateTime;
          if (!sortAscFlag) {
            setSortAscFlag(!sortAscFlag);
            if ( prevFname < nextFname ){
              return -1;
            }
            if ( prevFname > nextFname ){
              return 1;
            }
            return 0;
          } else {
            setSortAscFlag(!sortAscFlag);
            if ( prevFname < nextFname ){
              return 1;
            }
            if ( prevFname > nextFname ){
              return -1;
            }
            return 0;
          }   
        });
        setDisplayList([...newDisplayListDate]);
        break;
      default:
        break;
    }
  }

  const menu = (
    <Menu>
      <Menu.Item key="sortName" onClick={(event) => onSort(event.key)}>
        Sort by Name
      </Menu.Item>
      <Menu.Item key="sortSize"  onClick={(event) => onSort(event.key)}>
        Sort by Size
      </Menu.Item>
      <Menu.Item key="sortDate"  onClick={(event) => onSort(event.key)}>
        Sort by Date
      </Menu.Item>
    </Menu>
  );


  const downloadHandler = (data) => {
    const downloadUrl = fileUtils.getGalleryRenderUrl(
      galleryType.DOCUMENT,
      data.path,
      data.fileName
      )
    
    window.open(downloadUrl);
  }

  return (
    <div>
      <h2>เอกสาร</h2>
      <Breadcrumb>
        <Breadcrumb.Item>การจัดการแกลลอรี่</Breadcrumb.Item>
        <Breadcrumb.Item>เอกสาร</Breadcrumb.Item>
      </Breadcrumb>
      <Divider className="mt-2 mb-4" />
      <div className="d-flex">
        <div>
          {
            isHtmlModal === true ? (
              null
            ) : (
              <Button type="primary me-3" onClick={() => onAddDocument()}>
                <Icon.Image className="me-1" size={18} /> อัปโหลดเอกสาร
              </Button>
            )
          }
        </div>
        <div >
          {
            isHtmlModal === true ? (
              null
            ) : (
              <Button className="btn-line me-3" onClick={() => onAddFolder()}>
                <Icon.FolderPlus className="me-1" size={18} /> เพิ่มโฟล์เดอร์
              </Button>
            )
          }
        </div>
      </div>
      <Card className="mt-4" bordered={false}>
        <Collapse className="mb-4" defaultActiveKey={["1"]}>
          <Panel header="ตัวกรอง" key="1">
            <div>
              <Form layout="vertical">
                <Row gutter={20}>
                  <Col span={7}>
                    <Form.Item label="ชื่อเอกสาร" className="mb-0">
                      <Input 
                        name="fileName" 
                        value={condition.fileName} 
                        onChange={onChangeCondition} />
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item label="ชนิดเอกสาร" className="mb-0">
                      <Select allowClear value={condition.type} onChange={onChangeSelection}>
                        <Option key="doc" value="doc">doc</Option>
                        <Option key="docx" value="docx">docx</Option>
                        <Option key="pdf" value="pdf">pdf</Option>
                        <Option key="ppt" value="ppt">ppt</Option>
                        <Option key="pptx" value="pptx">pptx</Option>
                        <Option key="xls" value="xls">xls</Option>
                        <Option key="xlsx" value="xlsx">xlsx</Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col className="mt-4">
                    <Button type="primary" className="w-100" onClick={() => doSearch()}>
                      <Icon.Search className="me-1" size={18} /> ค้นหา
                    </Button>
                  </Col>
                  <Col className="mt-4">
                    <Button className="btn-gray" onClick={() => onClearSearch()}>ล้างค่า</Button>
                  </Col>
                </Row>
              </Form>
            </div>
          </Panel>
        </Collapse>
        <h5>เอกสาร</h5>
        <div className="d-flex justify-content-between" style={{ paddingBottom: '20px' }}>
          <Radio.Group buttonStyle="solid" onChange={displayGroupHandler} value={displayGroup}>
            <Radio.Button key="a" value="a">
              <Icon.Grid size={18} />
            </Radio.Button>
            <Radio.Button key="b" value="b">
              <Icon.List size={18} />
            </Radio.Button>
          </Radio.Group>

          <Dropdown overlay={menu} >
            <Button style={{ height: '32px' }}>
              {
                sortAscFlag === true ? (
                  <ArrowDownOutlined />
                ) : (
                  <ArrowUpOutlined />
                )
              }
              <OrderedListOutlined />
            </Button>
          </Dropdown>
          
        </div>
        <div className="p-3 border ">
          <div className="d-flex justify-content-between align-items-center">
            <Breadcrumb>
              <Breadcrumb.Item href="">
                <HomeOutlined />
              </Breadcrumb.Item>
              <Breadcrumb.Item onClick={() => doSearch()}>
                เอกสาร
              </Breadcrumb.Item>
              {
                currentParent === "root" ? (
                  null
                ) : (
                  <Breadcrumb.Item onClick={() => doSearch({parent: currentParent})}>
                    {currentFolder}
                  </Breadcrumb.Item>
                )
              }
            </Breadcrumb>
          </div>
          {displayGroup === 'a' ? 
            <div className="text-center my-4">
              {displayList ? (
                  <GalleryDocumentCard
                    axis={'x'}
                    items={displayList}
                    onRemove={onConfirmDelete}
                    onEdit={onClickEdit}
                    groupValue={galleryType.PHOTO}
                    embedMenuList={onEmbed}
                    editMenuList={onClickEdit}
                    openMenuList={onOpenFolder}
                    moveFile={moveFileHandler}
                    onDownload={downloadHandler}
                  />
                ) : (
                  <Empty />
                )}
            </div> 
            : 
            <div>
              {displayList ? (
                <ListDocumentCard
                    axis={'x'}
                    items={displayList}
                    onRemove={onConfirmDelete}
                    onEdit={onClickEdit}
                    groupValue={galleryType.PHOTO}
                    embedMenuList={onEmbed}
                    editMenuList={onClickEdit}
                    openMenuList={onOpenFolder}
                    moveFile={moveFileHandler}
                    onDownload={downloadHandler}
                />
              ) : (
                <Empty />
              )}
            </div>
          }
        </div>
      </Card>

      <AddEditFolderDialog 
          isShow={isShowAddFileDialog}
          editData={editFolderData}
          currentParent={currentParent}
          currentPath={currentPath}
          onCancel={onCancelAddFolder}
          onSaveComplete={onAddFolderComplete}>
      </AddEditFolderDialog>

      <AddEditDocumentDialog 
          isShow={isShowAddDocumentDialog}
          editData={editDocumentData}
          currentParent={currentParent}
          currentFolder={currentFolder}
          currentPath={currentPath}
          onCancel={onCancelAddDocument}
          onSaveComplete={onAddDocumentComplete}>
      </AddEditDocumentDialog>

    </div>
  );
};

export default Document;
